import { render } from "./PdfSettingsComponent.vue?vue&type=template&id=eee4e91a"
import script from "./PdfSettingsComponent.vue?vue&type=script&lang=js"
export * from "./PdfSettingsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__